import { render, staticRenderFns } from "./UsersMembersTab.vue?vue&type=template&id=6fddca80&scoped=true"
import script from "./UsersMembersTab.vue?vue&type=script&lang=js"
export * from "./UsersMembersTab.vue?vue&type=script&lang=js"
import style0 from "./UsersMembersTab.vue?vue&type=style&index=0&id=6fddca80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fddca80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fddca80')) {
      api.createRecord('6fddca80', component.options)
    } else {
      api.reload('6fddca80', component.options)
    }
    module.hot.accept("./UsersMembersTab.vue?vue&type=template&id=6fddca80&scoped=true", function () {
      api.rerender('6fddca80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/users-and-members-tab/UsersMembersTab.vue"
export default component.exports